import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Barra fixa logo abaixo do cabecalho: saldo, debito do carrinho, saldo
 * projetado, atalho para o extrato e o botao do carrinho com contador.
 */
@Component({
  selector: 'app-store-summary-bar',
  templateUrl: './store-summary-bar.component.html',
  styleUrls: ['./store-summary-bar.component.scss'],
})
export class StoreSummaryBarComponent {
  @Input() balance = 0;
  @Input() debit = 0;
  @Input() cartCount = 0;
  /** Enquanto a carteira nao carregou, mostra traco em vez de zero. */
  @Input() loading = false;
  /** Saldo nao pode ser lido: mostra aviso em vez de um "0" enganoso. */
  @Input() unknown = false;

  @Output() openCart = new EventEmitter<void>();

  get balanceAfter(): number {
    return (this.balance || 0) - (this.debit || 0);
  }

  get hasDebit(): boolean {
    return (this.debit || 0) > 0;
  }
}
